export function getProductDisplayId(productId) {
  const raw = String(productId || '').trim();

  if (!raw) {
    return 'PID-401';
  }

  const tail = raw.slice(-6);
  const numeric = Number.parseInt(tail, 16);

  if (Number.isNaN(numeric)) {
    return `PID-${raw.slice(0, 4).toUpperCase()}`;
  }

  return `PID-${(numeric % 9600) + 401}`;
}
